export default __webpack_public_path__ + "static/media/480_dummy2016-anwaltskanzlei01-mobile-de.2db46e24.png";